<template>
  <FlexColumn>
    <FlexRow justify="space-between" align="center">
      <Label :text="label" bold />
      <Button
        color="primary" text small
        @click="popup = !popup"
      >
        <Label
          :text="popup ? '閉じる' : '選択'"
          :bold="!popup && !hasSelectedPrefecture"
        />
      </Button>
    </FlexRow>
    
    <template v-if="popup">
      <v-card elevation="0" style="padding: 10px 6px 0 16px !important">
        <template v-for="region in regions">
          <FlexColumn :key="region.value" :space="0">
            <Label
              v-if="!(region.value === 'remote')"
              :text="region.label"
              color="primary" bold
            />
            <FlexRow :space="0" wrap class="pb-3">
              <v-checkbox
                v-for="prefecture in region.prefectures"
                :key="`prefecture-items-${prefecture.value}`"
                :label="prefecture.label"
                :value="prefecture.value"
                :input-value="value"
                :ripple="false"
                :style="style(region)"
                @change="handleChange(prefecture.value)"
              />
            </FlexRow>
          </FlexColumn>
        </template>
      </v-card>
    </template>
    
    <Label :text="prefecturesText" />
  </FlexColumn>
</template>

<script>
import {mapGetters} from "vuex"
import FlexRow from '../atoms/FlexRow'
import Label from '../atoms/Label'
import Button from '../atoms/Button'
import FlexColumn from '../atoms/FlexColumn'

export default {
  name: "ApplicantSearchPrefectureSelect",
  components: { FlexColumn, Button, Label, FlexRow },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: "希望勤務地"
    }
  },
  data() {
    return {
      popup: false,
    }
  },
  computed: {
    ...mapGetters("system", ["regions", "consts"]),
    hasSelectedPrefecture() {
      return this.value.length > 0
    },
    
    prefecturesText() {
      const canConvert = !!this.consts.preferredLocation
      return canConvert
        ? this.value.map(pref => this.convertPrefecture(pref)).join(' ')
        : undefined
    }
  },
  methods: {
    handleChange(prefectureId) {
      const alreadyChecked = this.value.includes(prefectureId)
      const data = alreadyChecked
        ? [...this.value].filter(id => id !== prefectureId)
        : [...this.value, prefectureId]
      this.$emit('input', data)
    },
    
    style(region) {
      const isRemoteOrOthers = region.value === 'remote' || region.value === 'others'
      return {
        height: '22px',
        width: isRemoteOrOthers ? '50%' : '33%'
      }
    },
    convertPrefecture(prefectureId) {
      const prefectures = this.consts.preferredLocation
      const index = prefectures.findIndex(pref => pref.value === prefectureId)
      return prefectures[index].label
    }
  }
}
</script>

<style scoped>
/** 不要なスペース等の削除 */
>>> .v-input--selection-controls {
  margin-top: 0 !important;
  padding-top: 0 !important;
}
>>> .v-input--selection-controls__input {
  margin-right: 2px !important;
}
>>> .v-menu__content--fixed {
  display: none !important;
}
</style>